const respWidth = 768;

const constants = {
    responsiveWidthThreshold: respWidth,
}

export default constants;